import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {timer} from 'rxjs';
import {PHONE_MASK} from '../../../helpers/format-helpers';
import {OrderService} from '../../services/order.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Product} from '../../../dto/product';


export const PHONE_SELECT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PhoneInputComponent),
  multi: true,
};


@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.css'],
  providers: [PHONE_SELECT_VALUE_ACCESSOR],
})
export class PhoneInputComponent implements OnInit, ControlValueAccessor {
  onChange;
  /**
   * Timer countdown,for reactivate button after press to send sms code
   */
  timer;
  /**
   * Timer current tick
   */
  ticks = 0;

  phoneMask = PHONE_MASK;


  /**
   * Variable bound with the phone form input field
   */
  phoneNumber;

  /**
   * Variable bound with the confirmation code form input field
   */
  confirmationCode;

  /**
   * Disable code form input if Send button never pressed
   */
  confirmationCodeInputDisabled = false;

  @Input() productId: number;
  @Output() nextStep: EventEmitter<any> = new EventEmitter();

  @Input()
  set phoneVerified(val: boolean) {
    this._phoneVerified = val;
  }

  _phoneVerified = false;
  phoneError: boolean;
  phoneInUseError: boolean;
  isSendingCode: boolean;

  constructor(private orderService: OrderService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    console.log(this.nextStep);
  }

  public resetControl() {
    this.phoneError = false;
    this.isSendingCode = false;
    this.phoneInUseError = false;
    this._phoneVerified = false;
    this.confirmationCode = '';
    this.confirmationCodeInputDisabled = false;
  }

  /**
   * Sending confirmation code to introduced phone,
   * if debtor with this code doesn't exist shows error,
   * if exist enable code field input
   */
  sendCode() {
    this.isSendingCode = true;
    this.orderService.sendMsgConfCode(this.productId, this.phoneNumber)
      .subscribe(
        result => {

          this.isSendingCode = false;

          if ( result.status === 1 ) {
            this.phoneInUseError = true;
            this.phoneError = false;
          } else if ( result.status === 2) {
            this.phoneInUseError = false;
            this.phoneError = true;
          } else {
            this.phoneInUseError = false;
            this.phoneError = false;
          }

          this.timer = timer(30, 1000);
          const subscription = this.timer.subscribe(t => {
            this.ticks = 30 - t;
            if (this.ticks == 0) {
              subscription.unsubscribe();
            }
          });
          if ( result.status === 0) {
this.confirmationCodeInputDisabled = true;
}
        },
        err => {
          this.isSendingCode = false;
          this.showMessage(this.translate.instant('ORDER.MOBILE.PHONE_ERROR'));
        });
  }

  /**
   * Try sign in with introduced phone and code
   */
  tryCode() {
    this.orderService.validateConfCode(this.phoneNumber, this.confirmationCode)
      .subscribe(result => {
        this.onChange({number: this.phoneNumber, confirmationCode: this.confirmationCode});
        this._phoneVerified = true;
        this.nextStep.emit();
      },
      err => {
        this.showMessage(err.error.Message);
        if (err.error.Message.includes('Send Message')) {
          this.confirmationCodeInputDisabled = false;
        }

      });

  }

  changeNumber() {
    this.confirmationCodeInputDisabled = false;
    this.confirmationCode = '';
  }

  /**
   * Return time in seconds, while send button wil be disabled
   */
  getTick() {
    return this.ticks != 0 ? ' (' + this.ticks + ')' : '';
  }

  writeValue(obj: any): void {

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }


  showMessage(msg){
    this.snackBar.open( msg, null, {
      duration: 15000,
      panelClass: [ 'app-mat-snack-bar' ]
    } );
  }
}
